import React from 'react'
import { Skeleton } from '@material-ui/lab'
// import { Link, useHistory } from 'react-router-dom'
import { useAppContext } from 'App'
import { Text } from 'shared/ui'
import useStyles from './styles.js'
import moment from 'moment'

const NotificationItem = (props) => {
  const { notification, onClose, isSkeleton } = props
  const appContext = useAppContext()
  const classes = useStyles()
  // const history = useHistory()

  if (isSkeleton) {
    return (
      <div className={classes.wrapNotificationItem}>
        <div className={classes.notificationItemTitle}>
          <Text variant="body2" style={{ fontWeight: 700, marginRight: '10px' }}>
            <Skeleton width={240} />
          </Text>
          <Text variant="body2" color="textMuted">
            <Skeleton width={32} />
          </Text>
        </div>
        <Text variant="body2" style={{ whiteSpace: 'break-spaces', maxWidth: '270px' }}>
          <Skeleton width={270} />
          <Skeleton width={240} />
          <Skeleton width={260} />
        </Text>
      </div>
    )
  }

  const idAppDetail = notification?.data?.object_uid
  const isAppIssue = notification?.data?.source == "alpha.apps.project.Issue"
  const isAppConversation = notification?.data?.source == "alpha.apps.conversation.Conversation"

  /** deprecated in favor of sidebar behavior */
  // let urlRedirect = ''
  // if (isAppIssue) {
  //   let projectKey = notification?.data?.issue?.project?.key
  //   urlRedirect = '/service/project/' + projectKey + '/view/' + idAppDetail
  // } else if (isAppConversation) {
  //   urlRedirect = '/conversations/all/view/' + idAppDetail
  // }

  /** handleClick now handles sidebar */
  const handleClick = () => {
    if (isAppConversation) {
      appContext.showSideBar(
        'conversations',
        'conversation-sidebar',
        {
          listKey: notification?.data?.groups?.[0] || 'all',
          conversationKey: idAppDetail
        }
      )
    } else if (isAppIssue) {
      appContext.showSideBar(
        'service',
        'issue-sidebar',
        {
          issueKey: idAppDetail,
          projectKey: notification?.data?.issue?.project?.key || 'all'
        }
      )
    }
    onClose()
  }

  const isSameAsToday = moment().isSame(moment(notification?.created_at), 'day')
  const iconNoRead = <div style={{ width: '8px', height: '8px', backgroundColor: '#ff6f00', borderRadius: '100%', marginRight: '5px' }} />

  return (
    <div className={classes.wrapNotificationItem} onClick={handleClick}>
      <div className={classes.notificationItemTitle}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {!notification.read_at && iconNoRead}
          <Text variant="body2" style={{ fontWeight: 700, marginRight: '10px' }}>{notification.title}</Text>
        </div>
        <Text variant="body2" color="textMuted">
          {isSameAsToday ? moment(notification?.created_at).format('HH:mm') : moment(notification?.created_at).format('D MMMM, HH:mm')}
        </Text>
      </div>
      <Text variant="body2" style={{ whiteSpace: 'break-spaces', maxWidth: '270px' }}>{notification.body}</Text>
    </div>
  )
}

export default NotificationItem